module.exports = __webpack_public_path__ + "static/media/UniversalTransactions_preview.5a8bc76e.PNG";